/* ============================================
   QUOTE WORKSTATION — Fees & Tax
   Asset: workstation-fees.js
   Fee status/value listeners, tax system (auto/manual/state rates), custom fees
   ============================================ */
(function() {
  'use strict';
  var Q = window.QWS;
  if (!Q) return;
  var state = Q.state;
  var dom = Q.dom;
  var wrap = Q.wrap;
  var fmt = Q.fmt;
  var parseMoney = Q.parseMoney;
  var escAttr = Q.escAttr;

  // Fee status change
  wrap.querySelectorAll('.rq-ws-fees__status').forEach(function(sel) {
    sel.addEventListener('change', function() {
      var feeKey = this.getAttribute('data-fee');
      if (feeKey === 'tax' || feeKey === 'cardFee') return; // handled by their own listeners
      var input = wrap.querySelector('.rq-ws-fees__input[data-fee="' + feeKey + '"]');
      var idx = feeKey === 'shipping' ? 0 : feeKey === 'installation' ? 1 : -1;
      if (idx === -1) return;
      state.fees[idx].status = this.value;
      if (this.value !== 'value') {
        input.style.display = 'none';
        state.fees[idx].amount = 0;
      } else {
        // Restore previously quoted amount when switching back to $
        var quoted = feeKey === 'shipping' ? state.freight.totalQuoted : feeKey === 'installation' ? state.installation.totalQuoted : 0;
        if (quoted > 0) {
          state.fees[idx].amount = quoted;
          if (input) input.value = fmt(quoted);
        }
        input.style.display = '';
      }
      state.dirty = true;
      Q.recalcTotals();
    });
  });

  // Fee value change
  wrap.querySelectorAll('.rq-ws-fees__input').forEach(function(input) {
    if (input.classList.contains('rq-ws-fees__tax-rate')) return; // tax rate handled separately
    input.addEventListener('input', function() {
      var feeKey = this.getAttribute('data-fee');
      var idx = feeKey === 'shipping' ? 0 : 1;
      state.fees[idx].amount = parseMoney(this.value);
      Q.liveFmtMoney(this);
      Q.recalcTotals();
    });
    input.addEventListener('focusout', function() {
      var raw = parseMoney(this.value);
      this.value = raw ? fmt(raw) : '';
    });
  });

  // Tax — state sales tax rates (approximate)
  var stateTaxRates = {
    AL:4,AZ:5.6,AR:6.5,CA:7.25,CO:2.9,CT:6.35,DC:6,DE:0,FL:6,GA:4,HI:4,ID:6,IL:6.25,
    IN:7,IA:6,KS:6.5,KY:6,LA:4.45,ME:5.5,MD:6,MA:6.25,MI:6,MN:6.875,MS:7,MO:4.225,
    MT:0,NE:5.5,NV:6.85,NH:0,NJ:6.625,NM:5.125,NY:4,NC:4.75,ND:5,OH:5.75,OK:4.5,
    OR:0,PA:6,RI:7,SC:6,SD:4.5,TN:7,TX:6.25,UT:6.1,VT:6,VA:5.3,WA:6.5,WV:6,WI:5,WY:4,AK:0
  };

  var taxModeSelect = wrap.querySelector('.rq-ws-fees__tax-mode');
  var taxRateInput = wrap.querySelector('.rq-ws-fees__tax-rate');

  function getAutoTaxRate() {
    var stateInput = wrap.querySelector('[data-field="state"]');
    var st = stateInput ? stateInput.value.trim().toUpperCase() : '';
    return stateTaxRates[st] || 0;
  }

  /* CUSTOM_AUTOTAX_BY_CLAUDE (Ryan 2026-10-30: "either exempt, or the actual rate, no other funny business") - TWO CHOICES: Auto (the
     stored mode stays 'pending', which is what the worker's offline tax keys on: Shopify works the rate out from the ship-to on save)
     and Exempt ('none'). The rate box beside it is READ ONLY: the rate Shopify used ("6.25% MA"), "On save" before the first save,
     "0% WY" where we hold no permit. A quote saved Manual % before this keeps its rate, shown read only, until the rep picks Auto or
     Exempt ("Manual (old quote)" is a hidden option the dropdown never offers). */
  /* CUSTOM_TAXRATEFMT_BY_CLAUDE (Ryan 2026-10-30) - never fewer than 2 decimals, never more than 3: 7.00%, 8.40%, 8.125%. */
  function fmtRate(r) {
    var pct = Math.round(Number(r) * 100000) / 1000;
    var t = pct.toFixed(3);
    return (t.charAt(t.length - 1) === '0' ? pct.toFixed(2) : t) + '%';
  }
  function autoTaxLabel() {
    var ot = state.offlineTax, tp = state.taxPlan;
    if (ot && ot.amount != null) {
      return { text: (ot.rate != null ? fmtRate(ot.rate) : 'Shopify') + (ot.state ? ' ' + ot.state : ''), title: 'Sales tax Shopify calculated for ' + (ot.state || 'this state') + ' at the last save' };
    }
    if (tp && tp.why === 'no-permit-in-state') return { text: '0% ' + tp.state, title: 'No tax: we hold no sales-tax permit in ' + tp.state };
    if (tp && tp.why === 'no-ship-to-state') return { text: 'Add address', title: 'Enter the ship-to address and save: Shopify works out the tax' };
    if (tp && tp.why === 'switch-off') return { text: 'Off', title: 'Automatic tax is switched off in Settings, Admin: Offline Deal Sales Tax' };
    return { text: 'On save', title: 'Save the quote: Shopify works out the tax from the ship-to address' };
  }

  function updateTaxUI() {
    var m = state.tax.mode;
    var taxIncl = wrap.querySelector('.rq-ws-fees__tax-includes');
    if (taxIncl) taxIncl.style.display = 'none';
    taxRateInput.readOnly = true;
    taxRateInput.tabIndex = -1;
    taxRateInput.style.opacity = '0.85';
    if (m === 'none') { taxRateInput.style.display = 'none'; taxRateInput.title = ''; return; }
    taxRateInput.style.display = '';
    if (m === 'pending') {
      var l = autoTaxLabel();
      taxRateInput.value = l.text;
      taxRateInput.title = l.title;
    } else {
      taxRateInput.value = (state.tax.rate || 0).toFixed(2) + '%';   // a quote saved Manual % before Auto existed
      taxRateInput.title = 'Set by hand before automatic tax. Pick Auto to let Shopify work it out, or Exempt.';
    }
  }

  taxModeSelect.addEventListener('change', function() {
    if (this.value !== 'pending' && this.value !== 'none') { this.value = state.tax.mode; return; }
    state.tax.mode = this.value;
    if (this.value === 'none') { state.tax.rate = 0; state.tax.amount = 0; }
    Q.recalcTotals();
  });
  /* END CUSTOM_AUTOTAX_BY_CLAUDE */

  wrap.querySelectorAll('.rq-ws-fees__tax-check-input').forEach(function(cb) {
    cb.addEventListener('change', function() {
      var key = this.getAttribute('data-tax-include');
      if (key === 'freight') state.tax.includeFreight = this.checked;
      if (key === 'installation') state.tax.includeInstallation = this.checked;
      Q.recalcTotals();
    });
  });

  taxRateInput.addEventListener('input', function() {
    var raw = this.value.replace(/[^0-9.]/g, '');
    state.tax.rate = parseFloat(raw) || 0;
    // Reformat with % suffix, preserve cursor
    var cursorPos = this.selectionStart;
    var digitsBefore = 0;
    for (var i = 0; i < cursorPos; i++) {
      if (/[0-9.]/.test(this.value[i])) digitsBefore++;
    }
    this.value = raw ? raw + '%' : '';
    // Restore cursor before the %
    var newPos = 0;
    var count = 0;
    for (var j = 0; j < this.value.length; j++) {
      if (/[0-9.]/.test(this.value[j])) { count++; if (count === digitsBefore) { newPos = j + 1; break; } }
    }
    if (!count) newPos = 0;
    this.setSelectionRange(newPos, newPos);
    Q.recalcTotals();
  });

  // Recalc tax when state changes (for auto mode)
  var stateField = wrap.querySelector('[data-field="state"]');
  if (stateField) {
    stateField.addEventListener('change', function() { if (state.tax.mode === 'auto') Q.recalcTotals(); });
    stateField.addEventListener('blur', function() { if (state.tax.mode === 'auto') Q.recalcTotals(); });
  }

  // Add custom fee
  wrap.querySelector('.rq-ws-fees__add-btn').addEventListener('click', function() {
    state.customFees.push({ title: '', amount: 0 });
    renderCustomFees();
  });

  function renderCustomFees() {
    var html = '';
    state.customFees.forEach(function(fee, idx) {
      html += '<div class="rq-ws-fees__custom-row">';
      html += '<div class="rq-ws-fees__custom-label-wrap">';
      html += '<input class="rq-ws-fees__custom-label" value="' + escAttr(fee.title) + '" placeholder="Fee name" data-custom-fee-idx="' + idx + '" data-custom-fee-field="title" spellcheck="false" autocomplete="off">';
      html += '</div>';
      html += '<button class="rq-ws-fees__custom-remove" data-custom-fee-idx="' + idx + '" type="button"><svg viewBox="0 0 20 20" width="100%" height="100%"><line x1="4" y1="4" x2="16" y2="16" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/><line x1="16" y1="4" x2="4" y2="16" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/></svg></button>';
      html += '<div class="rq-ws-fees__input-wrap">';
      if (fee.autoPercent) {
        html += '<input class="rq-ws-fees__input rq-ws-fees__custom-amount" value="' + (fee.amount ? fmt(fee.amount) : '$0.00') + '" data-custom-fee-idx="' + idx + '" data-custom-fee-field="amount" readonly style="opacity:0.6;cursor:default;">';
      } else {
        html += '<input class="rq-ws-fees__input rq-ws-fees__custom-amount" value="' + (fee.amount ? fmt(fee.amount) : '') + '" placeholder="$0.00" data-custom-fee-idx="' + idx + '" data-custom-fee-field="amount">';
      }
      html += '</div></div>';
    });
    dom.feesCustomRows.innerHTML = html;

    // Bind events
    dom.feesCustomRows.querySelectorAll('input').forEach(function(input) {
      input.addEventListener('input', function() {
        var idx = parseInt(this.getAttribute('data-custom-fee-idx'));
        var field = this.getAttribute('data-custom-fee-field');
        if (field === 'amount') {
          state.customFees[idx].amount = parseMoney(this.value);
          Q.liveFmtMoney(this);
          Q.recalcTotals();
        } else {
          state.customFees[idx].title = this.value;
          state.dirty = true;
          Q.recalcTotals(); // update totals labels
        }
      });
      if (input.getAttribute('data-custom-fee-field') === 'amount') {
        input.addEventListener('focusout', function() {
          var raw = parseMoney(this.value);
          this.value = raw ? fmt(raw) : '';
        });
      }
    });
    dom.feesCustomRows.querySelectorAll('.rq-ws-fees__custom-remove').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var idx = parseInt(this.getAttribute('data-custom-fee-idx'));
        state.customFees.splice(idx, 1);
        renderCustomFees();
        Q.recalcTotals();
      });
    });

  }

  // Exports
  Q.stateTaxRates = stateTaxRates;
  Q.getAutoTaxRate = getAutoTaxRate;
  Q.updateTaxUI = updateTaxUI;
  Q.renderCustomFees = renderCustomFees;
})();
